import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0d9994ec"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "UI__Title" }
const _hoisted_2 = ["tabindex"]
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  width: "80",
  height: "80",
  viewBox: "0 0 80 80",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "M48 32L32 48",
    stroke: "white",
    "stroke-linecap": "round"
  }),
  /*#__PURE__*/_createElementVNode("path", {
    d: "M32 32L48 48",
    stroke: "white",
    "stroke-linecap": "round"
  })
], -1))
const _hoisted_4 = [
  _hoisted_3
]
const _hoisted_5 = {
  key: 0,
  class: "UI__Detail"
}
const _hoisted_6 = {
  key: 0,
  class: "UI__Bottle"
}
const _hoisted_7 = ["innerHTML"]
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", null, [
  /*#__PURE__*/_createElementVNode("svg", { viewBox: "0 0 12 12" }, [
    /*#__PURE__*/_createElementVNode("use", { "xlink:href": "#i-grid" })
  ])
], -1))
const _hoisted_9 = { class: "UI__Nav UI__Nav--Previous" }
const _hoisted_10 = { class: "UI__Nav UI__Nav--Next" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ButtonHover = _resolveComponent("ButtonHover")!
  const _component_ButtonArrow = _resolveComponent("ButtonArrow")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["UI", { 'active': _ctx.isRewards, 'is-zoom-in': _ctx.isZoomIn }])
  }, [
    _createElementVNode("h2", _hoisted_1, _toDisplayString(_ctx.$t('backbar.title')), 1),
    _createElementVNode("button", {
      tabindex: _ctx.isRewards ? 0 : -1,
      "data-fixed": "",
      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.onClose && _ctx.onClose(...args))),
      to: "/my-profile",
      class: "UI__Close"
    }, _hoisted_4, 8, _hoisted_2),
    _createVNode(_Transition, { name: "fade" }, {
      default: _withCtx(() => [
        (_ctx.isZoomIn)
          ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
              _createElementVNode("ul", null, [
                (_openBlock(), _createElementBlock(_Fragment, null, _renderList(15, (i) => {
                  return _createElementVNode("li", {
                    key: 'bottle-detail-'+i
                  }, [
                    _createVNode(_Transition, { name: "fade" }, {
                      default: _withCtx(() => [
                        (i === _ctx.currentBottle)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                              _createElementVNode("h3", null, _toDisplayString(_ctx.$t('backbar.bottleTitle'+i)), 1),
                              _createElementVNode("p", {
                                innerHTML: _ctx.$t('backbar.bottleText' + i)
                              }, null, 8, _hoisted_7)
                            ]))
                          : _createCommentVNode("", true)
                      ]),
                      _: 2
                    }, 1024)
                  ])
                }), 64))
              ]),
              _createVNode(_component_ButtonHover, {
                tabindex: "-1",
                class: "UI__Detail__Button",
                onClick: _ctx.onZoomOut
              }, {
                default: _withCtx(() => [
                  _hoisted_8,
                  _createTextVNode(_toDisplayString(_ctx.$t('backbar.backToGridView')), 1)
                ]),
                _: 1
              }, 8, ["onClick"]),
              _createElementVNode("div", _hoisted_9, [
                _createVNode(_component_ButtonArrow, {
                  tabindex: "-1",
                  "data-fixed": "",
                  type: "button",
                  variant: "left",
                  size: "big",
                  color: "white",
                  onClick: _ctx.onPrevious
                }, null, 8, ["onClick"])
              ]),
              _createElementVNode("div", _hoisted_10, [
                _createVNode(_component_ButtonArrow, {
                  tabindex: "-1",
                  type: "button",
                  variant: "right",
                  size: "big",
                  color: "white",
                  onClick: _ctx.onNext
                }, null, 8, ["onClick"])
              ])
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    })
  ], 2))
}